// extracted by mini-css-extract-plugin
export default {"Root":"DefaultLayout_Root__TEGBn","PageLayout":"DefaultLayout_PageLayout__ahcX-","PageOutlet":"DefaultLayout_PageOutlet__hsqWi"};